// import React, { lazy, Suspense } from "react";
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import Navbar from "./components/Navbar/Navbar";
// import Spinner from "./components/Spinner/Spinner";
// import ProductList from "./pages/Products/ProductList";
// import SuccessTransact from "./components/Transaction/SuccessTransaction";
// import CardDetails from "./components/Transaction/CardDetails";

// const Cart = lazy(() => import("./pages/CartContent/CartItems"));

// // const Homepage = lazy(() => import("./pages/Home/Home"));

// //const Errorpage = lazy(() => import("./pages/Error/Error"));

// const Productlist = lazy(() => import("./pages/Products/ProductList"));

// const ProductDetails = lazy(() =>
//   import("./pages/SingleProduct/SingleProduct")
// );

// export default function App() {
//   return (
//     <Router>
//       <Navbar />
//       {/* <ProductList/> */}
//       <Suspense fallback={<Spinner />}>
//         <Switch>
//           {/* <Route exact path="/" component={Homepage}></Route> */}
//           <Route exact path="/cart" component={Cart}></Route>
//           <Route exact path="/" component={Productlist}></Route>
//           <Route exact path="/carddetails" component={CardDetails}></Route>
//           <Route exact path="/successtransact" component={SuccessTransact}></Route>
//           <Route
//             exact
//             path="/products/:id"
//             children={<ProductDetails />}
//           ></Route>
//           {/* <Route exact path="*" component={Errorpage}></Route> */}
//         </Switch>
//       </Suspense>
//     </Router>
//   );
// }

import "./App.css";
import Router from "./router/router";
import { Switch, Route, BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;
